export default __webpack_public_path__ + "proximanova-bold-webfont.woff2";